"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.destroyImage = exports.destroyAllImages = exports.addOnClick = exports.addOnMouseOut = exports.addOnMouseOver = exports.setInteractiveCircle = exports.setInteractive = void 0;
var common_sidecar_1 = require("../main/common-sidecar");
var clickEater_sidecar_1 = require("../uiParts/clickEater-sidecar");
var lodash_1 = require("./lodash");
function setInteractive(image, rect) {
    // Clear previous input?
    if (image.input) {
        // && image.input.enabled) {
        // common.getPhaserScene().input.disable(image)
        image.removeInteractive();
    }
    image.scrollFactorX = 0;
    image.scrollFactorY = 0;
    image.setInteractive(rect, rect
        ? function (_ha, x, y) {
            return rect.contains(x, y);
        }
        : undefined);
    image.input.cursor = 'pointer';
}
exports.setInteractive = setInteractive;
function setInteractiveCircle(image, circle) {
    // Clear previous input?
    if (image.input) {
        image.removeInteractive();
    }
    image.scrollFactorX = 0;
    image.scrollFactorY = 0;
    image.setInteractive(circle, circle
        ? function (_ha, x, y) {
            return circle.contains(x, y);
        }
        : undefined);
    image.input.cursor = 'pointer';
}
exports.setInteractiveCircle = setInteractiveCircle;
function addOnMouseOver(image, onMouseOver) {
    image.on('pointerover', function () {
        onMouseOver();
    });
}
exports.addOnMouseOver = addOnMouseOver;
function addOnMouseOut(image, onMouseOut) {
    image.on('pointerout', function () {
        onMouseOut();
    });
}
exports.addOnMouseOut = addOnMouseOut;
function addOnClick(image, onClick, autoEat) {
    if (autoEat === void 0) { autoEat = true; }
    image.on('pointerdown', function () {
        if (autoEat) {
            clickEater_sidecar_1.clickEater.tempEat();
        }
        var button = 0;
        var scene = common_sidecar_1.common.getPhaserScene();
        if (scene.game.input.activePointer.leftButtonDown()) {
            button = 1;
        }
        if (scene.game.input.activePointer.rightButtonDown()) {
            button = 2;
        }
        if (scene.game.input.activePointer.middleButtonDown()) {
            button = 3;
        }
        onClick(button);
    });
}
exports.addOnClick = addOnClick;
function destroyAllImages(images) {
    lodash_1.l.forEach(images, function (c) {
        c.destroy();
    });
    return [];
}
exports.destroyAllImages = destroyAllImages;
function destroyImage(image) {
    if (image) {
        image.destroy();
    }
    return null;
}
exports.destroyImage = destroyImage;
// imageBackground.on('pointerover', () => {
//   obj.isOver = true
// })
// imageBackground.on('pointerout', () => {
//   obj.isOver = false
//   obj.isMouseDown = false
// })
// imageBackground.on('pointerdown', () => {
//   clickEater.tempEat()
//   let scene = common.getPhaserScene()
//   if (scene.game.input.activePointer.rightButtonDown()) {
//     obj.isMouseRightDown = true
//   } else {
//     obj.isMouseDown = true
//   }
// })
// imageBackground.on('pointerup', () => {
//   clickEater.tempEat()
//   if (obj.isMouseDown) {
//     obj.isMouseDown = false
//     if (obj.imageBackground.visible) {
//       obj.onClick()
//     }
//   }
//   if (obj.isMouseRightDown) {
//     obj.isMouseRightDown = false
//   }
// })
// return obj
// }
